import React, { useEffect, useState, Fragment, Component, useRef } from 'react'
import { accessRole } from "../../../../helpers/access_role"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'

import TableComponent from './Components/TableComponent'

import IndexBloc from '../Index/Blocs/IndexBloc'

class DetailView extends Component {
    indexBloc = new IndexBloc()


    constructor(props) {
        super(props)
        this.activeRef = React.createRef()
        this.inactiveRef = React.createRef()
        this.state = {}
    }
    reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI()
    sendToBKNAll() {
        this.indexBloc.sendToBKNAll({
            process_uuid: this.props.uuid,
        })
    }
    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if (this.state.runType == 1) {
                    this.sendToBKNAll()
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.indexBloc.sendToBKNAllChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        let code = response.code

                        if (code == 0) {
                            this.setState({
                                loading: false,
                                failed: true,
                                loadingTable: false
                            });
                        } else {
                            this.setState({
                                loading: false,
                                success: true,
                                loadingTable: false
                            });
                            //this.loadData();
                            //this.handleIntegrasiJabatan()
                        }

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
    }
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>


                            <div className="float-end">

                                <Link to='/kepegawaian/integrasi_mutasi_simpeg_bkn.html' className="mr-3">
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                                {' '}
                                <Button
                                    color="success"
                                    type="button"
                                    onClick={() => {
                                        this.setState({
                                            confirm: true,
                                            runType: 1,
                                            confirmInfo: "Apakah anda yakin akan Mengirim semua data ini ke BKN?"
                                        })
                                    }}
                                >
                                    Kirim Seluruh Data Mutasi Jabatan Ke BKN
                                </Button>
                            </div>
                            <CardTitle>Daftar Integrasi Mutasi Jabatan</CardTitle>
                            <CardSubtitle className="mb-3">
                                Detail Daftar Integrasi Mutasi Jabatan
                            </CardSubtitle>
                            <hr />
                            <TableComponent uuid={this.props.uuid} ref={this.activeRef} handleInactiveSuccess={this.reloadInactiveRef} />
                        </CardBody>
                    </Card>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.state.confirmInfo}

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }
}
// const DetailView = (props) => {
//     const activeRef = useRef();
//     const inactiveRef = useRef();

//     const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

//     return (
//         <Fragment>
//             <Container fluid>
//                 <Card>
//                     <CardBody>


//                         <div className="float-end">

//                             <Link to='/kepegawaian/integrasi_mutasi_simpeg_bkn.html' className="mr-3">
//                                 <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
//                             </Link>
//                             {' '}
//                             <Button
//                                 color="success"
//                                 className="float-end"
//                                 type="button"
//                             >
//                                 Kirim Seluruh Data Mutasi Jabatan Ke BKN
//                             </Button>
//                         </div>
//                         <CardTitle>Daftar Integrasi Mutasi Jabatan</CardTitle>
//                         <CardSubtitle className="mb-3">
//                             Detail Daftar Integrasi Mutasi Jabatan
//                         </CardSubtitle>
//                         <hr />
//                         <TableComponent uuid={props.uuid} ref={activeRef} handleInactiveSuccess={reloadInactiveRef} />
//                     </CardBody>
//                 </Card>
//             </Container>
//         </Fragment>
//     )
// }
export default DetailView